import script from "./score-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./score-item.vue?vue&type=script&lang=ts&setup=true"

import "./score-item.vue?vue&type=style&index=0&id=c3a75bb6&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3a75bb6"]])

export default __exports__